import { useQuery } from "react-query";
import { API_URL } from "../../../../BaseUrlApi/Url";
import API from "@Config/axios";

export const useGetJob = (jobId) => {
  return useQuery(
    ["job", jobId],
    async () => {
      if (!jobId) return null;
      const response = await API.get(`${API_URL}/jobs/${jobId}`);
      return response.data.job.name;
    },
    { enabled: !!jobId }
  );
};
